 import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import classNames from 'classnames';;
import { connect } from 'react-redux';
import { Close } from '@mui/icons-material';

import { searchPages, searchTiles } from '../../services/reservoir';
import {
  createFavouritedTile,
  deleteFavouritedTile,
  getFavouritedTiles,
  getPersonalDetails,
  getReservoirApiUrl
} from '../../services/vu';
import { toggleSearch } from '../../actions/index';
import BodyClassName from 'react-body-classname';
import { getProperty } from '../../helpers/properties';;
import parse from 'html-react-parser';
import FocusTrap from 'focus-trap-react';
import { formatDate } from '../../actions/dateUtility';
import {getConfiguration} from "../../helpers/configuration";

const mapStateToProps = ({
  isSearchActive,
  courses: { selectedCourseCode, data },
  course: { selectedCourse },
  currentUser
}) => {
  return {
    isSearchActive: isSearchActive,
    admissionCategory: selectedCourse.admissionCategory,
    userRole: currentUser.data['role']
  };
};

const mapDispatchToProps = dispatch => {
  return {
    toggleSearch: () => {
      dispatch(toggleSearch(false));
    }
  };
};

class Search extends Component {
  constructor(props) {
    super(props);

    this.state = {
      favouritedTiles: [],
      reservoirApiUrl: '',

      tiles: [],
      pages: [],

      personalDetails: {
        studentId: '',
        dateOfBirth: ''
      },

      searchQuery: '',

      gtmSearchTimeout: null
    };
  }

  componentDidMount() {
    this.setState({
      searchQuery: ''
    });

    Promise.all([
      getFavouritedTiles(),
      getReservoirApiUrl(),
      getPersonalDetails()
    ]).then(([favouritedTiles, reservoirApiUrl, personalDetails]) => {
      this.setState({
        personalDetails: personalDetails,
        favouritedTiles: favouritedTiles,
        reservoirApiUrl: reservoirApiUrl
      });
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.location.pathname !== prevProps.location.pathname) {
      this.props.toggleSearch();
    }

    if (
      prevProps.isSearchActive !== this.props.isSearchActive &&
      this.props.isSearchActive
    ) {
      this.setState({
        searchQuery: ''
      });

      this.searchInput.focus();

      this.initialiseSearch();
    }

    if (this.state.searchQuery !== prevState.searchQuery) {
      this.initialiseSearch();
    }
  }

  initialiseSearch = () => {
    const searchQuery = this.state.searchQuery.trim();

    if (searchQuery.length > 2) {
      Promise.all([
        searchTiles(searchQuery),
        searchPages(searchQuery, this.props.admissionCategory)
      ]).then(([tileResults, pageResults]) => {
        this.setState(
          {
            tiles: tileResults.map(result => {
              return {
                ...result,
                photo: result.photo
                  ? `${this.state.reservoirApiUrl}${result.photo}`
                  : null
              };
            }),
            pages: pageResults
          },
          () => {
            clearTimeout(this.state.gtmSearchTimeout);

            if (searchQuery.length >= 3) {
              const timeout = setTimeout(() => {
                this.trackSearchComplete();
              }, 500);

              this.setState({
                gtmSearchTimeout: timeout
              });
            }
          }
        );
      });
    } else {
      this.setState({
        tiles: [],
        pages: []
      });
    }
  };

  trackSearchComplete = () => {
    window.dataLayer.push({
      event: 'custom.form.complete',
      group: 'MyVU Search',
      taxonomy: {
        category: 'Search'
      },
      info: {
        count: this.state.pages.length + this.state.tiles.length
      },
      data: {
        value: this.state.searchQuery
      }
    });
  };

  handleOnSubmit = event => {
    event.preventDefault();

    this.initialiseSearch();
  };

  handleOnChange = event => {
    this.setState({
      searchQuery: event.target.value
    });
  };

  handleOnKeyUp = ({ keyCode }) => {
    switch (keyCode) {
      case 27:
        this.handleClose();
    }
  };

  getResultCount = () => this.state.tiles.length + this.state.pages.length;

  handleClose = () => {
    if (this.props.isSearchActive) {
      this.trackSearchClose();

      this.setState(
        {
          searchQuery: '',
          tiles: [],
          pages: []
        },
        () => {
          this.props.toggleSearch();
        }
      );
    }
  };

  trackSearchClose = () => {
    window.dataLayer.push({
      event: 'custom.form.close',
      group: 'MyVU Search',
      labelContext: this.state.searchQuery,
      taxonomy: {
        category: 'Search'
      },
      info: undefined,
      data: {
        value: this.state.searchQuery
      }
    });
  };

  isFavouriteTile = uuid => {
    return this.state.favouritedTiles.includes(uuid);
  };

  submitFavouriteTileRequest = uuid => {
    const tileRequest = this.isFavouriteTile(uuid)
      ? deleteFavouritedTile
      : createFavouritedTile;

    tileRequest(uuid)
      .then(favouritedTile => getFavouritedTiles())
      .then(favouritedTiles => {
        this.setState({
          favouritedTiles: favouritedTiles
        });
      });
  };

  render() {
    return (
      <BodyClassName
        className={classNames(
          { 'search--active': this.props.isSearchActive },
          { 'search--inactive': !this.props.isSearchActive }
        )}
      >
        <FocusTrap
          className="search"
          active={this.props.isSearchActive}
          focusTrapOptions={{
            onDeactivate: this.handleClose
          }}
        >
          <div className="search">
            <button className="search__close" onClick={this.handleClose}>
              <span className="sr-only">Close Search form</span>
              <Close className="btn-point-events" />
            </button>
            <div className="container search__container">
              <div className="row">
                <div className="col-xs-12">
                  <form className="search__form" onSubmit={this.handleOnSubmit}>
                    <label htmlFor="searchInput" className="sr-only">
                      Search
                    </label>
                    <input
                      id="searchInput"
                      ref={input => {
                        this.searchInput = input;
                      }}
                      className="search__input"
                      placeholder="Search"
                      onChange={this.handleOnChange}
                      onKeyUp={this.handleOnKeyUp}
                      value={this.state.searchQuery}
                    />
                    <button className="search__button">
                      <span className="sr-only">
                        Search for "{this.state.searchQuery}"
                      </span>
                    </button>
                  </form>

                  {this.getResultCount() === 0 ? null : (
                    <div>
                      <div className="results-number">
                        <span>{this.getResultCount()}</span> results found
                      </div>

                      <div className="search__results">
                        <div className="row">
                          <div className="col-xs-12 col-md-8 col-lg-7">
                            {this.state.tiles.length > 0 && (
                              <div>
                                <h2>Tiles</h2>
                                <ul>
                                  {this.state.tiles.map((result, index) => {
                                    const handleFavouriteButtonClick = event => {
                                      event.preventDefault();

                                      window.dataLayer.push({
                                        event: `custom.tile.favourite.${
                                          this.isFavouriteTile(result.uuid)
                                            ? 'off'
                                            : 'on'
                                        }`,
                                        label: result.title,
                                        context: 'Search',
                                        labelContext: undefined,
                                        info: {
                                          url: result.url,
                                          id: result.uuid,
                                          location: undefined,
                                          position: index
                                        },
                                        data: {
                                          value: undefined,
                                          filters: [
                                            {
                                              type: 'Category',
                                              label: 'Everything'
                                            },
                                            {
                                              type: 'Location',
                                              label: 'All Campuses'
                                            }
                                          ]
                                        }
                                      });

                                      this.submitFavouriteTileRequest(
                                        result.uuid
                                      );
                                    };

                                    const handleTileClick = () => {
                                      window.dataLayer.push({
                                        event: 'custom.form.click',
                                        label: result.title,
                                        group: 'MyVU Search',
                                        taxonomy: {
                                          category: 'Search',
                                          subCategory: 'Results'
                                        },
                                        info: {
                                          url: result.url,
                                          count: this.state.tiles.length,
                                          position: index
                                        },
                                        data: {
                                          value: this.state.searchQuery
                                        }
                                      });
                                    };

                                    return (
                                      <li key={index}>
                                        <a
                                          className="result"
                                          href={result.url}
                                          onClick={handleTileClick}
                                        >
                                          {result.photo ? (
                                            <div
                                              className="result__thumbnail"
                                              style={{backgroundImage: `url(${result.photo})`}}
                                            />
                                          ) : null}
                                          <div className="result__text">
                                            <h3>{parse(result.title)}</h3>
                                            <p>
                                              {parse(result.description)}
                                            </p>
                                            <h5>
                                              {parse(result.field_calendar_)}
                                            </h5>
                                            {this.props.userRole == 'STUDENT' ? (
                                              <button
                                                className={classNames(
                                                  'favourite-button',
                                                  {
                                                    'favourite-button--favourited': this.isFavouriteTile(
                                                      result.uuid
                                                    )
                                                  }
                                                )}
                                                onClick={
                                                  handleFavouriteButtonClick
                                                }
                                                type="button"
                                              />
                                            ) : (
                                              ''
                                            )}
                                          </div>
                                        </a>
                                      </li>
                                    );
                                  })}
                                </ul>
                              </div>
                            )}
                          </div>

                          <div className="col-xs-12 col-md-4 col-lg-offset-1 col-lg-4">
                            {this.state.pages.length > 0 && (
                              <div>
                                <h2>Links</h2>
                                <ul>
                                  {this.state.pages.map((result, index) => {
                                    if (parseInt(result.field_onestop_override)) {
                                      return (
                                        <li key={index}>
                                          <form
                                            action={result.slug}
                                            method="post"
                                          >
                                            <input
                                              type="hidden"
                                              id="tran-type"
                                              name="tran-type"
                                              value="ESB001"
                                            />
                                            <input
                                              type="hidden"
                                              id="ESBStudentId"
                                              name="ESBStudentId"
                                              value={`ST${
                                                this.state.personalDetails
                                                  .studentId
                                              }`}
                                            />
                                            <input
                                              type="hidden"
                                              id="ESBStudentDateOfBirth"
                                              name="ESBStudentDateOfBirth"
                                              value={formatDate(
                                                this.state.personalDetails
                                                  .dateOfBirth,
                                                'dd/MM/yyyy'
                                              )}
                                            />
                                            <button
                                              type="submit"
                                              className="result"
                                            >
                                              <div className="result__text">
                                                <h3>
                                                  {parse(
                                                    result.heading
                                                      ? result.heading
                                                      : result.title
                                                  )}
                                                </h3>
                                                {result.body
                                                  ? parse(result.body)
                                                  : null}
                                              </div>
                                            </button>
                                          </form>
                                        </li>
                                      );
                                    }

                                    if (
                                      result.field_internal ||
                                      result.type === 'Page'
                                    ) {
                                      return (
                                        <li key={index}>
                                          <Link
                                            className="result"
                                            to={
                                              getConfiguration('baseUrl') +
                                              '/' +
                                              (result.slug === 'home'
                                                ? ''
                                                : result.slug)
                                            }
                                          >
                                            <div className="result__text">
                                              <h3>
                                                {parse(
                                                  result.heading
                                                    ? result.heading
                                                    : result.title
                                                )}
                                              </h3>
                                              {result.body
                                                ? parse(result.body)
                                                : null}
                                            </div>
                                          </Link>
                                        </li>
                                      );
                                    }

                                    return (
                                      <li key={index}>
                                        <a className="result" href={result.slug}>
                                          <div className="result__text">
                                            <h3>
                                              {parse(
                                                result.heading
                                                  ? result.heading
                                                  : result.title
                                              )}
                                            </h3>
                                            {result.body
                                              ? parse(result.body)
                                              : null}
                                          </div>
                                        </a>
                                      </li>
                                    );
                                  })}
                                </ul>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </FocusTrap>
      </BodyClassName>
    );
  }
}

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Search)
);
